export const scrollTopWithoutAnimation = () => window.scrollTo({
  top: 0,
  left: 0,
  behavior: 'instant',
});
